<div style="display: flex; flex-direction: column">
    @if (isBrandRating) {
        <div [ngClass]="showMenuFirst ? 'change-order' : ''">
            <app-brand-rating [isRepeatUser]="showMenuFirst"></app-brand-rating>
        </div>
    }
    <div class="container" style="order: 1" *appFeatureToggle="'landingShopByCategory'">
        @if (isMobile) {
            <app-mobile-shop-by-category [memberships]="memberships" (showMenu)="showMenuByCategory($event)" />
        } @else {
            <app-desktop-shop-by-category [memberships]="memberships" (showMenu)="showMenuByCategory($event)" />
        }

        <div class="clearfix"></div>
    </div>
</div>
